<template>
	<div>
		<swiper class="swiper_tab03" :options="swiperOption_tab03" ref="mySwiper_tab03">
			<swiper-slide :key="index" v-for="(item,index) in list">
				<component :is="item.component"></component>
			</swiper-slide>
		</swiper>
	</div>
</template>

<script>
	//二级导航组件 -- 言情
	import gdyq from '@/views/bookcity/gdyq.vue';
	import xdyq from '@/views/bookcity/xdyq.vue';
	import hxyq from '@/views/bookcity/hxyq.vue';
	export default {
		props: ['swiperIndexFirstSe02'],
		data() {
			const that = this
			return {
				list: [{
						component: gdyq
					},
					{
						component: xdyq
					},
					{
						component: hxyq
					}
				],
				mySwiper: null,
				//轮播图配置
				swiperOption_tab03: {
					spaceBetween: 0,
					centeredSlides: true,
					direction: 'horizontal',
					autoplay: false,
					loop: false,
					threshold : 50,
					pagination: {
						el: '.swiper-pagination',
						type: 'fraction',
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					observer: false,
					observeParents: false,
					// prevButton: ".swiper-button-prev",
					// nextButton: ".swiper-button-next",
					//滑动之后回调函数
					on: {
						slideChangeTransitionStart: function() {
							var swiper = that.$refs.mySwiper_tab03.$swiper;
							console.log(swiper.activeIndex, 'swiper.activeIndex')
							that.$emit('firSecondCateSlideTab02', swiper.activeIndex)
						},
					},
				},
			}
		},
		 computed: {
		    // 定义swiper，在下面就可以引用这个swiper了；
		    swiper03: function () {
		      return this.$refs.mySwiper_tab03.$swiper
		    },
		  },
		  mounted() {
		  	this.swiper03.slideTo(localStorage.getItem('secondCategroy02') || 0);
		  },
		watch: {
			swiperIndexFirstSe02(value, oldvalue) {
				// 接收 nav组件传过来的导航按钮索引，跳转到相应的内容区
				this.swiper03.slideTo(value, 0, false)
			}
		},
	}
</script>

<style>
</style>
